import React from "react";
import styled from "styled-components";
import Loader from "./simpleLoader";

const LoadingOverlay = styled.div`
  position: absolute;
  inset: 0;
  z-index: 30;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(17, 24, 39, 0.32);
  border-radius: inherit;
  padding: 20px;
`;

const LoadingCard = styled.div`
  width: 100%;
  max-width: 280px;
  min-height: 164px;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 28px 24px;
  text-align: center;

  .popup-loader {
    width: auto;
    flex: 0 0 auto;
    box-shadow: none;
    background: transparent;
  }

  .popup-loader svg {
    width: 48px;
    height: 48px;
  }
`;

function PopupLoader({
  isOpen = false,
  text = "\u10d3\u10d0\u10d4\u10da\u10dd\u10d3\u10d4",
}) {
  if (!isOpen) return null;

  return (
    <LoadingOverlay>
      <LoadingCard>
        <Loader className="popup-loader" />
      </LoadingCard>
    </LoadingOverlay>
  );
}

export default PopupLoader;
